import { FieldBlock } from '@coast/schemas';
import { isNil } from 'lodash';
import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBChannelImage } from '@shared/components/image';
import { CardChannelContext } from '../contexts/channel';
import { MBFieldBlock } from './field';

interface Props {
  block: FieldBlock;
  onPress?(): void;
}

export function MBFieldChannelBlock({ block, onPress }: Props) {
  const channel = useContext(CardChannelContext);
  if (isNil(channel)) {
    return null;
  }
  return (
    <MBFieldBlock
      value={channel?.name}
      block={block}
      onPress={onPress}
      renderLeft={() => (
        <View style={{ width: 30, height: 30 }} center>
          <MBChannelImage channel={channel} size="small" />
        </View>
      )}
    />
  );
}
